<template>
  <svg class="block" :style="styles">
    <use :href="`#${name}`" />
  </svg>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps<{
  name: string;
  width?: number;
  height?: number;
  color?: string;
}>();

const styles = computed(() => ({
  lineHeight: props.height ? `${props.height}px` : 'var(default-icon-size, inherit)',
  height: props.height ? `${props.height}px` : 'var(default-icon-size, inherit)',
  width: props.width ? `${props.width}px` : 'var(default-icon-size, inherit)',
  color: props.color ? `${props.color}` : '',
}));
</script>


